import ReactDOM from 'react-dom';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import Ru from './translations/ru.json';
import En from './translations/en.json';
import He from './translations/he.json';
import { CookiesProvider } from 'react-cookie';
import './_style/style.less';

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'ru',
  resources: {
    ru: {
      common: Ru,
    },
    en: {
      common: En,
    },
    he: {
      common: He,
    },
  },
});

ReactDOM.render(
  <I18nextProvider i18n={i18next}>
    <CookiesProvider>
      <App />
    </CookiesProvider>
  </I18nextProvider>,
  document.getElementById('root')
);
